import React from "react";

const ContainerHeading = ({ text, description, className }) => {
  const textClass = `sm:text-3xl text-2xl font-babas tracking-wider text-black dark:text-white text-center ${className}`;
  const descriptionClass = `sm:text-xl text-lg font-babas tracking-wider text-black dark:text-white text-center`;

  return (
    <>
      <p className={textClass}>{text}</p>
      {description && <p className={descriptionClass}>{description}</p>}
    </>
  );
};

export default ContainerHeading;
